import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctBytes32, FctValue } from '../../../../Fct/generics';
import { secureStorageAddresses } from '../helpers/constants';
export var Write_uint256 = createPlugin({
    protocol: 'SECURE_STORAGE',
    type: 'ACTION',
    method: 'write_uint256',
    supportedContracts: secureStorageAddresses,
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({}),
                methodParams: {
                    key: new FctBytes32({ messageType: 'stringOrBytes32' }),
                    value: new FctValue({}),
                },
            },
            output: {},
        });
    },
});
